import React, { FC } from "react";
import { RiTimerLine } from "react-icons/ri";
import { ANSWERSTATUSENUM } from "../../environment";

type ExamQuestionPanelProps = {
  timeLeft: {
    hours: string;
    minutes: string;
    seconds: string;
  };
  secondsAnimated: boolean;
  getStattusCount: (type: ANSWERSTATUSENUM) => any;
  getNotVisitCount: () => any;
  examQuestionDetails: any;
  handleChangeDisplay: (questionIndex?: number) => void;
  currentIndex: number;
  forMobile?: boolean;
  setCollapsed?: React.Dispatch<React.SetStateAction<boolean>>;
};

const ExamQuestionPanel: FC<ExamQuestionPanelProps> = ({
  timeLeft,
  currentIndex,
  handleChangeDisplay,
  examQuestionDetails,
  getNotVisitCount,
  getStattusCount,
  secondsAnimated,
  setCollapsed,
  forMobile,
}) => {
  return (
    <div
      className={`w-full bg-[#c7d2fe] p-4 rounded-lg shadow-lg  overflow-hidden border border-gray-300 md:mt-5 ${
        !forMobile ? `hidden h-[97.2%] md:block` : `h-[100%] `
      } `}
    >
      {/* Main (Fixed) */}
      <div className="hidden md:flex flex-col items-center gap-4 mt-4 ">
        {/* Time Left Label with Modern Design */}
        <div className="flex items-center gap-3">
          <div className="flex items-center bg-indigo-600 rounded-lg w-full h-10 px-3 py-1  shadow-md">
            <RiTimerLine size={22} className="text-white mr-1" />
            <span className="text-white font-semibold text-md">Time Left</span>
          </div>
          {/* Timer */}
          <div className="flex items-center gap-3">
            {/* Hours */}
            <div className="flex flex-col items-center">
              <div className="bg-indigo-600 rounded-lg w-10 h-10 relative">
                <h3 className="text-lg  font-semibold text-white text-center mt-3">
                  {timeLeft.hours}
                </h3>
                <p className=" absolute top-0 left-[30%] text-[10px] text-white">
                  Hrs
                </p>
              </div>
            </div>
            {/* Minutes */}
            <div className="flex flex-col items-center">
              <div className="bg-indigo-600 rounded-lg w-10 h-10 relative">
                <h3 className="text-lg  font-semibold text-white text-center mt-3">
                  {timeLeft.minutes}
                </h3>
                <p className=" absolute top-0 left-[30%] text-[10px] text-white">
                  Min
                </p>
              </div>
            </div>

            {/* Seconds */}
            <div className="flex flex-col items-center">
              <div className="bg-indigo-600 rounded-lg w-10 h-10 relative">
                <h3
                  className={`text-lg font-semibold text-white text-center mt-3  ${
                    secondsAnimated ? "animate-countinsecond" : ""
                  }`}
                >
                  {timeLeft.seconds}
                </h3>
                <p className=" absolute top-0 left-[30%] text-[10px] text-white">
                  Sec
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`grid grid-cols-2 lg:gap-3 w-full  md:mt-6 md:px-5 px-3 bg-gray-50 md:p-4 p-2 rounded-lg shadow-md border border-gray-300`}
      >
        <div className="col-span-1 flex py-2  items-center space-x-2">
          <div className="relative flex items-start  p-4 md:w-8 md:h-8 h-5 w-5 bg-green-500 border border-green-700 rounded-lg shadow-lg">
            {getStattusCount(ANSWERSTATUSENUM.ATTEMPT) > 0 ? (
              <div className=" p-[1px] absolute -top-2 -left-3 flex items-center justify-center w-6 h-6 bg-white text-green-700 text-sm font-bold rounded-full shadow-md border border-green-700">
                {getStattusCount(ANSWERSTATUSENUM.ATTEMPT)}
              </div>
            ) : (
              <></>
            )}
          </div>
          <span className=" font-semibold text-green-700 md:text-[13px] text-[12px]">
            Answered
          </span>
        </div>

        {/* <div className="flex items-center space-x-2">
          <div className="relative flex items-start p-4 md:w-8 md:h-8 h-5 w-5 bg-purple-500 border border-purple-700 rounded-lg shadow-lg">
            {getStattusCount(ANSWERSTATUSENUM.REVIEW) > 0 ? (
              <div className=" p-[1px] absolute -top-2 -left-3 flex items-center justify-center w-6 h-6 bg-white text-purple-700 text-sm font-bold rounded-full shadow-md border border-purple-700">
                {getStattusCount(ANSWERSTATUSENUM.REVIEW)}
              </div>
            ) : (
              <></>
            )}
          </div>
          <span className="text-base font-semibold text-purple-700 md:text-[13px] !text-[12px]">
            Marked for Review
          </span>
        </div> */}

        <div className="flex items-center space-x-2">
          <div className="relative flex items-start p-4 md:w-8 md:h-8 h-5 w-5 bg-blue-500 border border-blue-700 rounded-lg shadow-lg">
            {getStattusCount(ANSWERSTATUSENUM.SKIP) > 0 ? (
              <div className=" p-[1px] absolute -top-2 -left-3 flex items-center justify-center w-6 h-6 bg-white text-blue-700 text-sm font-bold rounded-full shadow-md border border-blue-700">
                {getStattusCount(ANSWERSTATUSENUM.SKIP)}
              </div>
            ) : (
              <></>
            )}
          </div>
          <span className=" font-semibold text-blue-700 md:text-[13px] text-[12px]">
            Skipped
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="relative flex items-start p-4 md:w-8 md:h-8 h-5 w-5 bg-gray-400 border border-gray-600 rounded-lg shadow-lg">
            {getNotVisitCount() > 0 ? (
              <div className=" p-[1px] absolute -top-2 -left-3 flex items-center justify-center w-6 h-6 bg-white text-gray-600 text-sm font-bold rounded-full shadow-md border border-gray-600">
                {getNotVisitCount()}
              </div>
            ) : (
              <></>
            )}
          </div>
          <span className=" font-semibold text-gray-700 md:text-[13px] text-[12px]">
            Not Visited
          </span>
        </div>
      </div>
      {/* Main end */}
      <hr className="mt-5    border-t-2 border-gray-400" />

      {!!examQuestionDetails &&
      examQuestionDetails?.sections &&
      !!examQuestionDetails?.sections &&
      Array.isArray(examQuestionDetails.sections) &&
      examQuestionDetails.sections.length > 1 ? (
        <div className="overflow-y-auto md:h-[calc(91vh-380px)] h-[calc(91vh-200px)]  mt-[10px] md:mt-[30px]   ">
          <div className="space-y-6 mt-4">
            {!!examQuestionDetails.questions &&
              examQuestionDetails?.sections &&
              Array.isArray(examQuestionDetails.questions) &&
              Object.entries(
                examQuestionDetails.questions.customGroupBy(
                  (self: any) => self.section
                )
              )
                .sort((a, b) => a[0].localeCompare(b[0]))
                .map(([sectionKey, value]: any, pindex: number) => {
                  return (
                    <div
                      key={pindex}
                      className="relative flex flex-col  border border-gray-200 rounded-lg p-4 shadow-md bg-white mb-4 md:mt-[60px]"
                    >
                      <div className="flex flex-col items-center">
                        <div className="absolute -top-4  bg-white rounded-full px-4 py-1 border border-gray-300 shadow text-sm font-semibold text-gray-900">
                          {sectionKey}
                        </div>
                      </div>

                      {/* Grid of Items */}

                      <div className="mt-2 gap-3 !gap-x-2 grid 2xl:grid-cols-6 xl:grid-cols-6 lg:grid-cols-5 sm:grid-cols-4 grid-cols-6    ">
                        {value.map((item: any, nestedIndex: number) => {
                          const isSelected =
                            currentIndex === item?.questionIndex;
                          const statusColor =
                            item?.status === ANSWERSTATUSENUM.ATTEMPT
                              ? "bg-green-500"
                              : item?.status === ANSWERSTATUSENUM.REVIEW
                              ? "bg-purple-500"
                              : item?.status === ANSWERSTATUSENUM.SKIP
                              ? "bg-blue-500"
                              : "bg-gray-400";

                          return (
                            <div
                              key={item?.questionIndex}
                              onClick={() => {
                                handleChangeDisplay(item?.questionIndex || 0);
                                setCollapsed?.(false);
                              }}
                              className={`w-10 h-10  flex justify-center items-center  cursor-pointer ${statusColor} ${
                                isSelected
                                  ? "border-2 border-black animate-pulse shadow-xl transform scale-110 "
                                  : "shadow-md"
                              }  text-white transition-all rounded-lg`}
                            >
                              <span className="text-sm font-semibold">
                                {item?.questionIndex
                                  ? item.questionIndex + 1
                                  : 1}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>
      ) : (
        <></>
      )}

      {(!!examQuestionDetails &&
        examQuestionDetails?.sections &&
        !!examQuestionDetails?.sections &&
        Array.isArray(examQuestionDetails.sections) &&
        examQuestionDetails.sections.length === 0) ||
      examQuestionDetails.sections.length === 1 ? (
        <div className="overflow-y-auto md:h-[calc(91vh-380px)] h-[calc(91vh-250px)]   rounded-lg   bg-white pt-3 shadow-lg  mt-[10px] md:mt-[60px]">
          <div className="flex flex-wrap md:mx-4 ">
            {examQuestionDetails.questions &&
              Array.isArray(examQuestionDetails.questions) &&
              examQuestionDetails.questions?.map((item: any, key: any) => (
                <div
                  key={item?.questionIndex}
                  onClick={() => {
                    handleChangeDisplay(
                      item?.questionIndex ? item.questionIndex : 0
                    );
                    setCollapsed?.(false);
                  }}
                  className={`w-8 h-8   bg-gray-300 m-2 flex justify-center items-center rounded-md ${
                    currentIndex === item?.questionIndex
                      ? "border-2 border-black cursor-pointer animate-pulse"
                      : ""
                  } ${
                    item?.status === ANSWERSTATUSENUM.ATTEMPT
                      ? "!bg-green-500 text-white cursor-pointer"
                      : ""
                  } ${
                    item?.status === ANSWERSTATUSENUM.REVIEW
                      ? "!bg-violet-500 text-white cursor-pointer"
                      : ""
                  } ${
                    item?.status === ANSWERSTATUSENUM.SKIP
                      ? " !bg-blue-500 text-white cursor-pointer"
                      : ""
                  }`}
                >
                  {item?.questionIndex ? item.questionIndex + 1 : 1}
                </div>
              ))}
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ExamQuestionPanel;
